<template>
<div class="aboutPage">
	<div class="aboutImageBox" ref="headerImageRef">
		<img class="aboutImage" src="@/assets/aboutIMG.png" />
		<div class="aboutTextBox">
			<div class="aboutTitle" style="margin-top: 3rem;">
				以科技为文脉，以关怀为核<br />
				Technology as the Pulse, Care as the Core
			</div>
			<div class="aboutText" style="margin-top: 3rem;">
				从PULSE，让身心健康管理更科学、更可及<br />
				PULSE: Making Mind & Body Wellness Management Smarter & More Accessible
			</div>
		</div>
	</div>
	<div style="height: 11.7rem; width: 1px;" />

	<div class="profileBox">
		<div class="boxCNTitle">
			公司简介
		</div>
		<div style="width: 1px; height: 1rem" />

		<div class="boxENTitle">
			COMPANY PROFILE
		</div>
		<div style="height: 6.7rem; width: 1px;" />

		<div class="profileBoxText">
			PULSE（上海芊贺科技有限公司）是国家级高新技术企业，专注于心理健康领域数字化产品研发与运营。公司以“AI 技术中台 + 多终端产品 + 全场景服务”为核心架构，构建覆盖 C/B/G 端的数字心理健康生态，深度整合 20 余家三甲医院、北师大、中科院等专家资源，打造“数据监测—分析—个性化干预”全链条解决方案。目前已服务 3 个教育局、5 家企业，覆盖用户超 30 万人，以技术赋能让身心健康管理更科学、更可及。
			<br />
			<br />
			公司以科技赋能与人文关怀，守护全民身心健康，构筑普惠可及的社会健康支持体系，致力于成为国内领先的身心健康数字化解决方案提供商，并始终坚守科技驱动、专业赋能、人文关怀、全域覆盖的核心价值观。
		</div>
		<div style="height: 5.3rem; width: 1px;" />
		<img class="profileBoxImage" src="@/assets/about0.png" />
	</div>
	<div style="height: 11.7rem; width: 1px;" />

</div>
</template>

<script>
export default {
	data() {
		return {
		}
	},
	methods: {
		emitHeroHeight() {
			const height = this.$refs.headerImageRef ? this.$refs.headerImageRef.offsetHeight : 20;
			this.$emit("headerImageRefHeight", height);
		}
	},
	created() {
	},
	mounted() {
		this.emitHeroHeight();
		window.addEventListener("resize", this.emitHeroHeight);
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.emitHeroHeight);
	},
	watch: {
	},
}
</script>

<style lang="scss" scoped>
.aboutPage {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;

	.aboutImageBox {
		width: 100%;
		height: 51.4rem;
		position: relative;
		background-color: #212121;

		.aboutImage {
			width: 100%;
			height: 100%;
			position: absolute;
			top: 0px;
			left: 0px;
			object-fit: cover;
		}

		.aboutTextBox {
			position: absolute;
			width: 1200px;
			left: calc((100% - 1200px) / 2);
			top: 20%;
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			justify-content: center;

			.aboutTitle {
				font-size: 5.3rem;
				text-align: left;
				color: #FFFFFF;
			}
			.aboutText {
				font-size: 1.5rem;
				line-height: 2.5rem;
				text-align: left;
				color: #FFFFFF;
			}
		}
	}

	.profileBox {
		width: 100%;
		position: relative;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;

		.profileBoxText {
			box-sizing: border-box;
			width: 100rem;
			font-size: 1.5rem;
			line-height: 2.4rem;
			color: #333333;
			text-align: left;
		}
		.profileBoxImage {
			box-sizing: border-box;
			width: 100rem;
			height: auto;
		}
	}

	
}

.boxCNTitle{
	font-size: 4rem;
	line-height: 4.8rem;
	color: #1D1D1F;
	font-weight: 600;
}
.boxENTitle{
	font-size: 1.7rem;
	line-height: 1.8rem;
	color: #666666;
}
</style>